<template>
  <div v-if="shouldRenderConfig && showButton" :class="getClassName">
    <button type="button" class="btn btn-primary" @click="quotationButton">
      {{ $t(name) }}
    </button>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useUrlsStore } from "@/stores/modules/urls";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

import axios from "../../axios-auth";

export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getSelectionId",
      "getHideQuotationButton"
    ]),
    ...mapState(useUrlsStore, ["getIsQuotationUrlSet", "getUrl"]),
    ...mapState(useChangeOptionsStore, [
      "getQuantities",
      "getChangeOptionsDataPPOpt"
    ]),
    name: function () {
      return "Quotation";
    },
    showButton: function () {
      return !this.getHideQuotationButton && this.getIsQuotationUrlSet;
    }
  },
  methods: {
    ...mapActions(useWebproductStore, ["openFancybox"]),
    quotationButton: function () {
      const _qtys = [];

      this.getQuantities.forEach(item => {
        _qtys.push({
          ...item,
          formatted_base_price: item.formatted_base_price || "",
          formatted_price_per_unit: item.formatted_price_per_unit || ""
        });
      });

      var _data = [this.getChangeOptionsDataPPOpt, _qtys];
      var url =
        this.getUrl(axios.quotationUrl) +
        "?selection=" +
        btoa(unescape(encodeURIComponent(JSON.stringify(_data))));

      this.openFancybox({ src: url });
    }
  }
};
</script>
